import styled from "styled-components";

function TextHome2(){
    return(
        <TextSpam>
            <h2>A prioridade é a diversão!</h2>
            Diversão é o que há! Afinal, você veio até aqui em busca dela, não é mesmo?<br/><br/>

            Para garantir sua diversão, nosso servidor conta com eventos como a <b>Devil Square</b>, o <b>Evento Bandeira do Brasil</b>, as <b>WoE 1.0</b> e <b>2.0</b>, instâncias e quest's <b>mais atuais</b>.<br/><br/>

            Nosso servidor conta ainda com as árenas <b>Player x Player (PvP)</b>, <b>Guild x Guild (GvG)</b> e a <b>Monster x Monster (MxM)</b>, com partidas <b>casuais</b> e <b>rankeadas</b>.<br/><br/>
            
            Além disso, também premiamos nossos jogadores com o evento <b>Presença LionsRag</b> que garante pontos para os jogadores que peramencem <b>ativos a cada 1 hora</b> de jogo.<br/><br/>
            
            Temos também o <b>Colecionador de Artefatos</b> que confere pontos aos jogadores em trocas de itens raros que são conseguidos <b>derrotando MVP's</b> (Chefes) do jogo.<br/><br/>

            E claro, tudo isso com premiações e classificações com homenagens, que você confere na seção <b>Ranking's</b>.
        </TextSpam>
    );
};

const TextSpam = styled.span`
`;

export default TextHome2;